export default __webpack_public_path__ + "static/media/PAV_Logo_White.4372eb3b.png";